import type { ReportConfigurationType } from '@api';
import {
  AddActionIcon,
  ReportVariantUnionType,
  TouringCard,
  TouringCardActions,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { useReportMailingsTableColumns } from './hooks';

type ReportMailingsTablePropsType = {
  variant: ReportVariantUnionType;
  mailings: ReportConfigurationType[];
  canAdd: boolean;
  onAdd: () => void;
  canEdit: boolean;
  onEdit: (mailing: ReportConfigurationType) => void;
  onDelete: (mailingId: string) => void;
};

export const ReportMailingsTable: React.FC<ReportMailingsTablePropsType> = ({
  variant,
  mailings,
  canAdd,
  onAdd,
  canEdit,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const { columns } = useReportMailingsTableColumns({
    variant,
    canEdit,
    onEdit,
    onDelete,
  });

  return (
    <TouringCard data-testid="report-mailings-container">
      <TouringCardHeader>
        <TouringCardTitle>{t('REPORTS.MAILINGS.TITLE')}</TouringCardTitle>
        {canAdd && (
          <TouringCardActions>
            <AddActionIcon
              onClick={onAdd}
              ariaLabel={t('REPORTS.MAILINGS.ADD')}
            />
          </TouringCardActions>
        )}
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<ReportConfigurationType>
          records={mailings}
          columns={columns}
          noRecordsText={t(`REPORTS.MAILINGS.EMPTY.${variant}`)}
          withTableBorder={false}
          withColumnBorders={false}
          highlightOnHover={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
